import { useEffect, useState } from "react";
import { getAudioStatus, subscribeAudioStatus, unlockAudio } from "@/lib/audio";

/**
 * AudioDiagnostic — fixed-position pill in the bottom-right that reports
 * the live audio playback status. TEMPORARY — remove once we're happy
 * with the voice pipeline in production.
 *
 * States:
 *   locked → amber · "Tap to Enable"
 *   ready  → green · "Audio Ready"
 *   error  → red   · "Audio Error"
 */
export default function AudioDiagnostic() {
  const [state, setState] = useState(getAudioStatus);

  useEffect(() => subscribeAudioStatus(setState), []);

  const { status, error } = state;
  const cfg =
    status === "ready"
      ? { color: "#34D399", label: "Audio Ready", icon: "🔊" }
      : status === "error"
      ? { color: "#F43F5E", label: "Audio Error", icon: "❌" }
      : { color: "#FBBF24", label: "Tap to Enable", icon: "🔇" };

  const clickable = status !== "ready";

  return (
    <button
      type="button"
      onClick={clickable ? unlockAudio : undefined}
      aria-label={cfg.label}
      title={error ? `${cfg.label} — ${error}` : cfg.label}
      data-testid="audio-diagnostic-pill"
      data-audio-status={status}
      className="fixed bottom-3 right-3 z-[70] inline-flex items-center gap-2 px-3 py-1.5 rounded-full border font-mono-aviation text-[11px] uppercase tracking-[0.22em] transition-transform"
      style={{
        background: "rgba(6,11,20,0.85)",
        borderColor: `${cfg.color}88`,
        color: "#F8FAFC",
        backdropFilter: "blur(6px)",
        boxShadow: `0 0 12px ${cfg.color}55`,
        cursor: clickable ? "pointer" : "default",
      }}
    >
      <span
        aria-hidden
        className="inline-block w-2 h-2 rounded-full"
        style={{
          background: cfg.color,
          boxShadow: `0 0 8px ${cfg.color}`,
          animation: status === "ready" ? "audio-diag-pulse 2s ease-in-out infinite" : "none",
        }}
      />
      <span>{cfg.icon} {cfg.label}</span>
      <style>{`
        @keyframes audio-diag-pulse {
          0%, 100% { opacity: 0.85; }
          50% { opacity: 1; }
        }
      `}</style>
    </button>
  );
}
